import { render, staticRenderFns } from "./GovProposalList.vue?vue&type=template&id=7af1c382&"
import script from "./GovProposalList.vue?vue&type=script&lang=js&"
export * from "./GovProposalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports